export default {
  list: require('./List').default,
}